module.exports = __webpack_public_path__ + "img/avatar-6.442f02b8.jpg";